import React, { useRef } from "react";
import "./searchfilter.css";
import { useEffect } from "react";
import api from "../../../seller-apis/api";
import { useState } from "react";

/**
 * This component is used on Brand Page, Apply For Brand Page
 */
let searchResultClicked = false;
function OrderSKUSearch(props) {
  let timer = null;
  const [fuzzySearches, setFuzzySearches] = useState([]);
  const [searchType, setSearchType] = useState("product Name");
  const [newEnqName, setnewEnqName] = useState("");
  const [value, setValue] = useState("");
  const searchContainerRef = useRef(null);
  const skipFuzzySearch = useRef(false);
  const isResetting = useRef(false);
  //I1-2330
  const firstRender = useRef(true); // track initial render
  // Reset search type when resetSearchType prop changes

  useEffect(() => {
    if (props.resetSearchType > 0) {
      isResetting.current = true;
      setSearchType("product Name");
      setValue("");
      setFuzzySearches([]);
      // Reset the flag after a short delay
      setTimeout(() => {
        isResetting.current = false;
      }, 100);
    }
  }, [props.resetSearchType]);


  useEffect(() => {
    // Skip first render entirely | Ticket : I1-2330
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    console.log(searchResultClicked)
    if (value != "" && searchResultClicked === false) {
      
      let timeoutId = setTimeout(() => { }, 500);
      timeoutId = setTimeout(() => fuzzySearch(), 1000);

      return () => clearTimeout(timeoutId);
    }

    //SL-675 
    if(value === "" && (props?.flag === "Opportunity" || props?.flag === "Product" || props?.flag === "Order") && !isResetting.current) 
      props?.apiCall("reset")
  }, [value]);

  useEffect(() => {
    // Add click event listener to document
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setFuzzySearches([]); // Hide suggestions when clicking outside
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      // Cleanup listener on component unmount
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const fuzzySearchOld = async () => {
    
    console.log('Search ProductId Length',props?.totalRcordId?.length)
    let param = "";
    let filed = "";
    if (searchType == "sku") {
      param = { "SKU-partial": value };
      filed = { "productName": 1, "SKU": 1 }
    } else {
      param = { "productName-fuzzy": value };
      filed = { "productName": 1, "SKU": 1 }
    }

    let paramData = props?.data === "filedData" ? {
      filter: { ...param },
      otherFilter: { ...props.searchParam },
      excludeField: { ...filed },
    } : {
      filter: { ...param },
      otherFilter: { ...props.searchParam },
      //SL-675 Search Issue
      excludeField: { ...filed },
    };
    //SL-675
    paramData["productId"] = props?.totalRcordId ? props.totalRcordId : []
    const data = props.apiurl === "OtherSellerProducts"
            ? await api.product.searchOtherSellerProducts(paramData)
            : await api.product.searchSellerProductsFilter(paramData);
    //Skip result if Enter was just pressed
    console.log('fuzzySearch ',skipFuzzySearch.current)
    if (!skipFuzzySearch.current) {
      setFuzzySearches(data.products);
    } else {
      setFuzzySearches([]); // just in case, ensure dropdown stays hidden
    }
    /*props.apiurl === "OtherSellerProducts" ? api.product.searchOtherSellerProducts(paramData).then((data) => {
      setFuzzySearches(data.products);
    }) :
      api.product.searchSellerProducts(paramData).then((data) => {
        setFuzzySearches(data.products);
      });*/
  };

  const fuzzySearch = async () => {
  // Add check for skipFuzzySearch at the start
  if (skipFuzzySearch.current) {
    return;
  }
  
  console.log('Search ProductId Length',props?.totalRcordId?.length)
  let param = "";
  let filed = "";
  if (searchType == "sku") {
    param = { "SKU-partial": value };
    filed = { "productName": 1, "SKU": 1 }
  } else {
    param = { "productName-fuzzy": value };
    filed = { "productName": 1, "SKU": 1 }
  }

  let data;

  if (props.apiurl === "searchSellerOrdersFilter") {
    // Flatten spclFilter + filters from the orders globalFilter into a single `filter`
    const gf = props.ordersSearchParam || {};
    const paramData = {
      filter: {
        ...param,
        ...(gf.spclFilter || {}),
        ...(gf.filters || {}),
        ...(gf.filter || {}),
        ...(gf.orderFilter || {})
      },
      excludeField: { productName: 1, SKU: 1, productId: [] },
    };
    data = await api.order.searchSellerOrdersFilter(paramData);
  } else {
    let paramData = props?.data === "filedData" ? {
      filter: { ...param },
      otherFilter: { ...props.searchParam },
      excludeField: { ...filed },
    } : {
      filter: { ...param },
      otherFilter: { ...props.searchParam },
      excludeField: { ...filed },
    };

    paramData["productId"] = props?.totalRcordId ? props.totalRcordId : []

    data = props.apiurl === "OtherSellerProducts"
      ? await api.product.searchOtherSellerProducts(paramData)
      : await api.product.searchSellerProductsFilter(paramData);
  }

  // Check again after async operation
    if (!skipFuzzySearch.current) {
      let uniqueProducts = [
        ...new Map(data.products.map(item => [item.SKU, item])).values()
      ];
    setFuzzySearches(uniqueProducts);
  } else {
    setFuzzySearches([]);
  }
};

  /**
   * Handle the Enter
   */
  const handleEnterPress = async () => {
    console.log('handleEnterPress')
    if(props?.searchByKeyword && value.trim()){
      try {
            // block fuzzySearch temporarily
            skipFuzzySearch.current = true;
            const param = searchType === "sku"
            ? { "SKU-partial": value }
            : { "productName-fuzzy": value };

            let data;
            if (props.apiurl === "searchSellerOrdersFilter") {
              const gf = props.ordersSearchParam || {};
              const paramData = {
                filter: {
                  ...param,
                  ...(gf.spclFilter || {}),
                  ...(gf.filters || {}),
                  ...(gf.filter || {}),
                  ...(gf.orderFilter || {})
                },
                excludeField: { productName: 1, SKU: 1, productId: [] },
              };
              data = await api.order.searchSellerOrdersFilter(paramData);
            } else {
              const paramData = {
                filter: { ...param },
                otherFilter: { ...props.searchParam },
                excludeField: { productName: 1, SKU: 1 },
                productId: props?.totalRcordId || []
              };
              // Fetch fresh results
              data = props.apiurl === "OtherSellerProducts"
              ? await api.product.searchOtherSellerProducts(paramData)
              : await api.product.searchSellerProductsFilter(paramData);
            }
            const productIds = data.products.map((item) => item._id);
            if(productIds.length > 0) 
              props.searchByKeyword(value, searchType, productIds);
            else 
              props.searchByKeyword(value, searchType, []); // handle empty case too
            
            setFuzzySearches([]);

      } catch (error) {
        console.error("Enter search failed", error);
      }
      finally {
        // reset after a short delay to allow typeahead to resume
        setTimeout(() => {
          skipFuzzySearch.current = false;
          console.log('setTimeout ',skipFuzzySearch.current)
        }, 1000);
      }
    }
  };

  
  return (
    <>
      <div class="search-container">
        <select
          onChange={(e) => {
            setValue("")
            setSearchType(e.target.value);
          }}
        >
          <option value="product Name">Product Name</option>
          <option value="sku">SKU</option>
          {props?.from!== "orders" && <option value="HSN">HSN</option>}
        </select>
      </div>
      <div class="search-container relative">
        {searchType === "HSN" && props?.from !== "orders" ? (
          <select
            onChange={(e) => {
              const hsnFilter = e.target.value;
              if (hsnFilter === "Products without HSN") {
                props.onHSNFilterChange({
                  "HSN": { $exists: false }
                });
              }
              else if (hsnFilter === "Products with HSN") {
                props.onHSNFilterChange({
                  "$and": [
                    { "HSN": { $exists: true } },
                    { "HSN": { $ne: "" } }
                  ]
                });
              }
              else {
                // Remove hsnFilter - pass null to clear
                props.onHSNFilterChange(null);
              }
            }}
            defaultValue="All"
            style={{ width: "100%", padding: "4px 8px", borderRadius: "3px", fontSize: "14px", border: "1px solid #ccc" }}
          >
            <option value="All">All HSN</option>
            <option value="Products without HSN">Products without HSN</option>
            <option value="Products with HSN">Products with HSN</option>
          </select>
        ) : (
          <>
            <input
              type="text"
              value={value}
              placeholder="Search ..."
              onChange={(e) => {
                searchResultClicked = false
                setValue(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleEnterPress(); // SL-675
                }
              }}
            />
            {/* <button type="button" onClick={() => props.searchNewEnq()}>
              <i class="fa fa-search"></i>
            </button> */}
            {fuzzySearches && fuzzySearches.length > 0 ? (
              <div className="search-drop" ref={searchContainerRef}>
                <ul>
                  {fuzzySearches.map((product) => {
                    return (
                      <li
                        key={product._id}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent event bubbling
                          searchResultClicked = true
                          
                          // Set flag to prevent fuzzy search from interfering
                          skipFuzzySearch.current = true;
                          
                          const selectedData = props.from == "orders" 
                            ? product._id 
                            : searchType == 'sku' 
                              ? product.SKU 
                              : product.productName;
                          
                          setnewEnqName(selectedData);
                          
                          // Update input value to show selection
                          setValue(searchType == 'sku' ? product.SKU : product.productName);
                          
                          // Clear dropdown immediately
                          setFuzzySearches([]);
                          
                          // Call filter search with product ID
                          props.filterSearch({ data: product._id, type: searchType });
                          
                          // Reset flag after a delay
                          setTimeout(() => {
                            skipFuzzySearch.current = false;
                          }, 500);
                        }}
                      >
                        {searchType == 'sku' ? product.SKU : product.productName}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
}

export default OrderSKUSearch;